import { render, staticRenderFns } from "./bulk-link.vue?vue&type=template&id=6b9720d2&scoped=true&"
import script from "./bulk-link.vue?vue&type=script&lang=js&"
export * from "./bulk-link.vue?vue&type=script&lang=js&"
import style1 from "./bulk-link.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9720d2",
  null
  
)

export default component.exports